import type React from "react";
import { useEffect, useRef } from "react";
import { isElementDescendantOfClassName } from "../utils/window.util";

const googleAutocompleteContainerClassName = "pac-container";
const baseUiPortalSelector = "[data-base-ui-portal]";

type Props = {
    children: React.ReactNode;
    className?: string;
    onClickOutside: (event: globalThis.MouseEvent) => void;
    disabled?: boolean;
};

const HandleClicksOutside = function HandleClicksOutside({
    children,
    className,
    onClickOutside,
    disabled,
}: Props) {
    const ref = useRef<HTMLDivElement>(null);
    const isDisabled = disabled || false;

    useEffect(() => {
        if (isDisabled) return undefined;

        const handleClick = (ev: globalThis.MouseEvent) => {
            const target = ev.target as HTMLElement;

            // Google autocomplete is always in the root level of elements
            if (
                isElementDescendantOfClassName(
                    target,
                    googleAutocompleteContainerClassName,
                )
            ) {
                return;
            }

            if (target.closest(baseUiPortalSelector)) {
                return;
            }

            if (ref.current && !ref.current.contains(target)) {
                onClickOutside(ev);
            }
        };

        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [onClickOutside, isDisabled]);

    return (
        <div ref={ref} className={className}>
            {children}
        </div>
    );
};

export default HandleClicksOutside;
